/**
 * V2 Contact reason categories — static bilingual catalog.
 * Stable internal values match the backend allowlist in
 * backend/models.py::CONTACT_REASON_VALUES.
 */
const V2_CONTACT_CATEGORIES = [
  { value: 'general',                label: { en: 'General question',            es: 'Pregunta general' } },
  { value: 'partnership_referral',   label: { en: 'Partnership / referral',      es: 'Alianza / referido' } },
  { value: 'speaking_collaboration', label: { en: 'Speaking / collaboration',    es: 'Conferencia / colaboración' } },
  { value: 'media_press',            label: { en: 'Media / press',               es: 'Medios / prensa' } },
  { value: 'existing_client',        label: { en: 'Existing client',             es: 'Cliente actual' } },
  { value: 'other',                  label: { en: 'Other',                       es: 'Otro' } },
];

export default V2_CONTACT_CATEGORIES;
